/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import { Box, Typography, Paper } from "@mui/material";

const McqMultipleQuestion = ({ question, selectedAnswer = [], currentIndex, onSelect, onClear}) => {
  let parsedOptions = [];

  try {
    const parsed =
      typeof question?.options === "string"
        ? JSON.parse(question.options)
        : question.options;

    parsedOptions = parsed?.mcqOptions || parsed || [];
  } catch {
    parsedOptions = [];
  }

  const toggleOption = (value) => {
    let updated;

    if (selectedAnswer.includes(value)) {
      updated = selectedAnswer.filter((item) => item !== value);
    } else {
      updated = [...selectedAnswer, value];
    }

    onSelect(updated);
  };

  return (
    <Box sx={{ p: "16px 20px !important" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px", fontFamily: "system-ui, -apple-system, sans-serif" }}>
        <span style={{ fontSize: "17px", fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>Question {currentIndex + 1}</span>
        <span style={{ padding: "4px 12px", borderRadius: "6px", border: "1.5px solid #60a5fa", color: "#2563eb", fontSize: "11px", fontWeight: 700, letterSpacing: "0.04em" }}>MULTIPLE CORRECT</span>
      </div>

      {/* Question Text */}
      <Paper elevation={0} sx={{ p: "12px 16px", borderRadius: "12px", backgroundColor: "#ffffff", border: "1px solid #e5e7eb", mb: 2 }}>
        <Typography dangerouslySetInnerHTML={{ __html: question?.question_text }} sx={{ fontSize: 14, color: "#111827", lineHeight: 1.7, fontWeight: 400 }} />
      </Paper>
      

     

      {/* Options */}
      <>
        {parsedOptions.map((option, index) => {
          const isSelected = selectedAnswer.includes(option);
          const optionLabel = String.fromCharCode(65 + index); // A B C D

          return (
            <Paper key={index} elevation={0} onClick={() => toggleOption(option)}
              sx={{
                display: "flex", alignItems: "center", px: 2, py: 1.2, mb: 1, borderRadius: "12px", cursor: "pointer",
                border: isSelected ? "1.5px solid #3b82f6" : "1.5px solid #e5e7eb",
                backgroundColor: isSelected ? "#eff6ff" : "#ffffff", transition: "all 0.15s ease",
                "&:hover": { borderColor: isSelected ? "#3b82f6" : "#c7d2e8", backgroundColor: isSelected ? "#eff6ff" : "#f9fafb" }
              }}>
              {/* Left Letter Box */}
              <Box sx={{ width: 28, height: 28, fontSize: 13, mr: 2, borderRadius: "50%", backgroundColor: isSelected ? "#dbeafe" : "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: isSelected ? "#2563eb" : "#374151", flexShrink: 0 }}>
                {optionLabel}
              </Box>

              <Typography sx={{ fontSize: 13.5, color: "#1f2937", fontWeight: isSelected ? 500 : 400, lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: option }} />
            </Paper>
          );
        })}
      </>
    </Box>
  );
};

export default McqMultipleQuestion;